import React from 'react';
import { Check, Star, Zap, Crown, Rocket } from 'lucide-react';
import { Button } from '../components/ui/button';

const PLANS = [
  {
    name: 'Starter',
    price: 29,
    icon: Zap,
    color: '#D98324',
    features: [
      'Negozio online con URL personalizzato',
      'Upload foto + AI automatica',
      'Fino a 50 prodotti attivi',
      'Catalogo con categorie personalizzate',
      'Condivisione social (link)',
      'Gestione ordini base',
      'Logo e personalizzazione negozio',
      'Supporto email',
    ],
    cta: 'Inizia con Starter',
    setup: 199,
  },
  {
    name: 'Professional',
    price: 69,
    icon: Star,
    color: '#C25934',
    popular: true,
    features: [
      'Tutto dello Starter +',
      'Prodotti illimitati',
      'Scansione barcode prodotti',
      'Telegram Bot automatico',
      'Volantino digitale del giorno',
      'Dashboard ordini con statistiche',
      'Notifiche WhatsApp clienti',
      'Report vendite mensile',
      'Supporto prioritario',
    ],
    cta: 'Scegli Professional',
    setup: 199,
  },
  {
    name: 'Business',
    price: 109,
    icon: Crown,
    color: '#4A6B53',
    features: [
      'Tutto del Professional +',
      'Dominio personalizzato',
      'Multi-utente (3 operatori)',
      'Pagamenti online (Stripe + PayPal)',
      'Notifiche push nuovi prodotti',
      'Analytics avanzate',
      'Supporto telefonico',
    ],
    cta: 'Scegli Business',
    setup: 399,
  },
  {
    name: 'Enterprise',
    price: 299,
    icon: Rocket,
    color: '#2A2624',
    features: [
      'Tutto del Business +',
      'Fino a 5 punti vendita',
      'API personalizzate',
      'Posting auto Facebook/Instagram',
      'Gestione inventario avanzata',
      'Account manager dedicato',
      'Personalizzazioni su richiesta',
      'SLA garantito 99.9%',
    ],
    cta: 'Contattaci',
    setup: 399,
  },
];

export default function PricingPage() {
  return (
    <div data-testid="pricing-page" className="pb-safe px-4 pt-6 max-w-4xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-3xl sm:text-4xl font-semibold text-[#2A2624] tracking-tight" style={{ fontFamily: 'Outfit' }}>
          Scegli il tuo piano
        </h1>
        <p className="text-[#5C554F] mt-2 text-base" style={{ fontFamily: 'Manrope' }}>
          Scatta, vendi, condividi. Tutto dal tuo cellulare.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {PLANS.map(plan => {
          const Icon = plan.icon;
          return (
            <div
              key={plan.name}
              data-testid={`plan-${plan.name.toLowerCase()}`}
              className={`bg-white rounded-2xl border-2 p-5 relative transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                plan.popular ? 'border-[#C25934] shadow-md' : 'border-[#E8E3D9]'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C25934] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                  Consigliato
                </div>
              )}

              <div className="flex items-center gap-2 mb-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${plan.color}15` }}>
                  <Icon size={20} style={{ color: plan.color }} />
                </div>
                <h3 className="text-lg font-semibold text-[#2A2624]" style={{ fontFamily: 'Outfit' }}>
                  {plan.name}
                </h3>
              </div>

              <div className="mb-4">
                <span className="text-3xl font-bold text-[#2A2624]" style={{ fontFamily: 'Outfit' }}>
                  {plan.price}&euro;
                </span>
                <span className="text-sm text-[#877E78]">/mese</span>
                <p className="text-[10px] text-[#877E78] mt-0.5">Setup: {plan.setup}&euro; una tantum</p>
              </div>

              <ul className="space-y-2 mb-5">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-[#5C554F]">
                    <Check size={14} className="mt-0.5 flex-shrink-0" style={{ color: plan.color }} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <Button
                data-testid={`cta-${plan.name.toLowerCase()}`}
                className="w-full h-11 rounded-full text-white text-sm font-semibold"
                style={{ backgroundColor: plan.color }}
              >
                {plan.cta}
              </Button>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-8 mb-4">
        <p className="text-sm text-[#877E78]">
          Primo mese a 9&euro; per tutti i piani. Nessun vincolo, cancella quando vuoi.
        </p>
      </div>
    </div>
  );
}
